module.exports = __webpack_public_path__ + "img/week-off-option.b94f0d08.png";